module.exports = __webpack_public_path__ + "static/media/monero.98410fd7.svg";